// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2UzqX","inner":"Footer_inner__30U1s","nextIcon":"Footer_nextIcon__2oMc2","innerLeft":"Footer_innerLeft__3yRT9"};